var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5303 16.9981C12.2374 17.291 11.7626 17.291 11.4697 16.9981L3.96967 9.4981C3.67678 9.20521 3.67678 8.73034 3.96967 8.43744C4.26256 8.14455 4.73744 8.14455 5.03033 8.43744L12 15.4071L18.9697 8.43744C19.2626 8.14455 19.7374 8.14455 20.0303 8.43744C20.3232 8.73034 20.3232 9.20521 20.0303 9.4981L12.5303 16.9981Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightLight);
export default __webpack_public_path__ + "static/media/chevron-right-light.8b83c7c986b9e0a0be95cd782cfc27bb.svg";
export { ForwardRef as ReactComponent };